import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import template from './index.jade';
import css from './shadow.styl?inline';
import './index.styl';

export interface AuthContainerJsxProps {
  attrs?: {
    'show-promo-line'?: boolean;
    'show-company-logos'?: boolean;
    'show-footer-links'?: boolean;
    'hide-header'?: boolean;
  };
}

export class AuthContainer extends Component<EmptyObj, AuthContainerJsxProps['attrs']> {
  static get attrsSchema(): AttrsSchema<AuthContainerJsxProps['attrs']> {
    return {
      'show-promo-line': `boolean`,
      'show-company-logos': `boolean`,
      'show-footer-links': `boolean`,
      'hide-header': `boolean`,
    };
  }
  get config() {
    return {
      css,
      useShadowDom: true,
      template,
    };
  }
}

export const AuthContainerEl = defineAndMakeJsxFactory<AuthContainerJsxProps>(`auth-container`, AuthContainer);
